import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ApiMondiConstants } from "../../constants/api-constants/api-mondi.constants";
let MondiModuleService = class MondiModuleService {
    http;
    constructor(http) {
        this.http = http;
    }
    getApplicationSetPropertiesObservable(applicationId, params) {
        return this.http.post(`${ApiMondiConstants.URL}/${applicationId}/${ApiMondiConstants.FUNCTION_SET_LOCATION}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    getMapDataObservable(moduleId, params) {
        return this.http.get(`${ApiMondiConstants.URL}/${moduleId}/${ApiMondiConstants.FUNCTION_GET_MND_MAP_DATA}`, { params })
            .pipe(map((data) => {
            return data;
        }));
    }
    getMappedLayerDataObservable(moduleId, params) {
        return this.http.get(`${ApiMondiConstants.URL}/${moduleId}/${ApiMondiConstants.FUNCTION_GET_MAPPED_LAYER_DATA}`, { params })
            .pipe(map((data) => {
            return data;
        }));
    }
    getCompartmentsDataByCode(moduleId, params) {
        return this.http.get(`${ApiMondiConstants.URL}/${moduleId}/${ApiMondiConstants.FUNCTION_GET_COMPARTMENT_DATA_BY_CODE}`, { params })
            .pipe(map((data) => {
            return data;
        }));
    }
    getSetLocationObservable(applicationId, params) {
        return this.http.post(`${ApiMondiConstants.URL}/${applicationId}/${ApiMondiConstants.FUNCTION_SET_LOCATION}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
MondiModuleService = __decorate([
    Injectable({
        providedIn: "root"
    })
], MondiModuleService);
export { MondiModuleService };
